import { Component } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {AuthenticationService} from '../../../../core/services/authentication/authentication.service';
import {UserInfo} from '../../../../core/models/user/user-info.model';

@Component({
  selector: 'app-settings-profile',
  imports: [
    TranslateModule],
  templateUrl: './settings-profile.component.html',
  styleUrl: './settings-profile.component.scss'
})
export class SettingsProfileComponent {

  constructor(
    private readonly authService: AuthenticationService
  ) { }

  get user(): UserInfo | undefined {
    return this.authService.userData;
  }

  get userEmail(): any {
    return this.user?.email;
  }

}
